// Run a function after Slate has finished processing an event, which needs to
// wait until at least the next animation frame and then for more than `setTimeout()`.
const runAfterSlate = (func: () => void) => {
  requestAnimationFrame(() => {
    setTimeout(() => {
      func();
    }, 10);
  });
};

export default runAfterSlate;
